<template>
  <div :class="$options.name">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    const loader = document.getElementById('app-loader')
    if (loader) loader.remove()
    document.body.style.overflow = 'auto'
  }
}
</script>
